import RegisterPage from "./register";

export default RegisterPage;